import React from 'react';

import Button from '../../../../components/UI/button/button';

import styles from './styles.module.scss';

export default function ChargedOff({
  title,
  description,
  selfService,
  onlineChat,
  email,
  appDescription,
  phoneNumber,
  onClickPhoneNumber,
  whatsapp,
  onClickWhatsapp,
}) {
  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <img src="/image/ic_celular_erro_instalacao.png" alt="Imagem de celular" />

        <div className={styles.circle} />

        <h2>{title}</h2>

        <p>{description}</p>
      </div>

      <div className={styles.content}>
        {selfService && (
          <b>
            Autoatendimento:{' '}
            <span>
              <a href={selfService} target="_blank" rel="noopener noreferrer">
                {selfService.replace('https://', '')}
              </a>
            </span>
          </b>
        )}

        {onlineChat && (
          <>
            <br />
            <b>
              Chat Online:{' '}
              <span>
                <a href={onlineChat} target="_blank" rel="noopener noreferrer">
                  {onlineChat.replace('https://', '')}
                </a>
              </span>
            </b>
          </>
        )}

        {email && (
          <>
            <br />
            <b>
              Email: <span>{email}</span>
            </b>
          </>
        )}

        {appDescription && (
          <>
            <br />
            {appDescription}
          </>
        )}
      </div>

      <div className={styles.footer}>
        {phoneNumber && (
          <Button onClick={onClickPhoneNumber} rounded background="#ED2E45">
            <img src="/image/white-phone.png" alt="Icone do whatsapp" /> {phoneNumber}
          </Button>
        )}

        {whatsapp && (
          <Button onClick={onClickWhatsapp} rounded background="#ED2E45">
            <img src="/image/whatsapp-white.png" alt="Icone do whatsapp" /> {whatsapp}
          </Button>
        )}
      </div>
    </div>
  );
}
